// extracted by css-extract-rspack-plugin
export default {"root":"AXVjz","bordered":"A1rwW"};